module.exports = __webpack_public_path__ + "img/16.e597dc6e.png";